import { render, staticRenderFns } from "./authorized.vue?vue&type=template&id=3a087de2&"
import script from "./authorized.vue?vue&type=script&lang=js&"
export * from "./authorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports